<template>
  <div :class="['yayaLand-page', `page-step-${pageStep}`]">
    <div v-wechat-title="'【最强蜗牛】不思议乐园专题页'"></div>

    <div class="end-page" v-if='showEndPage'></div>
    <div v-else>
      <!-- 登录弹窗 -->
      <Login v-if='isShowLogin' :gameName="gameName" :game_id="'39'" :downloadUrl="downloadUrl" :loginTypes="loginTypes"
        :autoOpenOS="autoOpenOS" v-on:loginSuccess="loginSuccess" @selectCallback="loginCallback"
        channelTips="角色UID可在游戏中—设置—UID查看"></Login>
      <Os v-if='isShowOs' v-on:logoutCallback='osCancell' @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
      <!-- 头部 -->
      <div class="header" v-if='showNavigation'>
        <div class="text top">最强蜗牛</div>
        <div class="text bottom">{{ userInfo.user_id ? `${userInfo.server_name}-${userInfo.role_name}` : '你的童年，我的童年，好像不一样'
        }}
        </div>
        <div class="btn download" @click="downloadApps" data-snail-report-name="下载游戏">
        </div>
        <div class="btn login" v-show="!userInfo.user_id" @click="changeLoginPopup(true)"></div>
        <div class="btn switch" v-show="userInfo.user_id" @click="changeOsPopup(true)"></div>
      </div>

      <!-- 内容 -->
      <div class="active-page">
        <!-- 阶段 1：预热期 -->
        <div v-if="pageStep === 1" class="stage-content stage-content-1">
          <div class="stage-main">
            <div class="top-meta">
              <span>本网站最后更新: 2005-06-19</span>
              <span>已安全运行 2182 天</span>
            </div>
            <div class="main-title"></div>
            <div class="countdown-box">
              <div class="time-box">
                <div class="time-block"><span>{{ formatTimeNum(timeLeft.days) }}</span></div>
                <div class="time-block"><span>{{ formatTimeNum(timeLeft.hours) }}</span></div>
                <div class="time-block"><span>{{ formatTimeNum(timeLeft.minutes) }}</span></div>
                <div class="time-block"><span>{{ formatTimeNum(timeLeft.seconds) }}</span></div>
              </div>
            </div>
            <div class="contact-info">
              <p class="tel-num">
                寻物热线：0592-3337153
              </p>
            </div>
            <div class="guestbook-box"></div>
          </div>
          <div class="footer">
            <div class="footer-content"></div>
          </div>
        </div>

        <!-- 阶段 2 / 阶段 3 -->
        <div v-else-if="pageStep === 2 || pageStep === 3" :class="['stage-content', `stage-content-${pageStep}`]">
          <!-- 用户信息 -->
          <div class="profile-card">
            <div class="avatar">
              <img :src="userAvatar" />
            </div>
            <div v-if="userInfo.user_id" class="user-info">
              <div class="top-info-box">
                <div class="name">{{ userName }}</div>
                <div v-if="userInfo.user_id" class="level">Lv.{{ level }}</div>
              </div>
              <div class="signature">{{ userSign }}</div>
            </div>
            <div v-else class="unlogin-user-info">
              <div class="tips"></div>
            </div>
            <div class="action-container">
              <!-- 分享图标 -->
              <img src="../../../../assets/images/active/snail/yayaLand/head/share_btn.png" class="btn-icon share-btn"
                @click="handleShare" data-snail-report-name="分享主页-复制链接" data-event="复制分享主页链接"
                :data-clipboard-text="'《最强蜗牛》·不思议乐园，快来我的专属主页，给我点踩留言，共同调查乐园吧！记得不要跑堂哦~' + pageShareLink"
                id="share-clipboard-btn" />

              <!-- BGM 开关图标 (动态切换) -->
              <img
                :src="isAudio ? require('../../../../assets/images/active/snail/yayaLand/head/music_on.png') : require('../../../../assets/images/active/snail/yayaLand/head/music_off.png')"
                class="music-btn btn-icon" @click="audio()" />
            </div>
          </div>

          <!-- 板块切换 -->
          <div class="tab-bar">
            <div v-for="(item, index) in tabs" :key="index" class="tab-wrapper" @click="switchTab(index)">
              <img :src="activeIndex === index ? item.active : item.normal"
                :class="['tab-img', { 'is-active': activeIndex === index }]" />
            </div>
          </div>
          <div v-if="isOtherHome" class="back-my-home-btn" @click="backToMyHome"></div>

          <!-- 活动页 -->
          <div v-show="activeIndex === 0" class="tab-page tab-page-active" :class="[`tab-page-${pageStep}`]">
            <!-- 隐藏的丫丫日记分享 -->
            <div class="diary-share-container" ref="diaryShareDom">
              <!-- 顶部标题栏 -->
              <div class="diary-header">
                <div class="title">{{ userInfo.user_id ? userInfo.role_name : '' }}的丫丫日记</div>
                <div class="right-dec-text">SUPER SNAIL</div>
              </div>

              <!-- 日记列表 -->
              <div class="diary-list">
                <div v-for="(item, i) in shareDiaryList" :key="item.id" class="diary-item"
                  :class="{ 'is-abnormal': item.status !== 0 }">
                  <div class="diary-row">
                    <!-- 固定装饰图标：爱心(0)、蓝星(1)、黄星(2)循环 -->
                    <img :src="getFixedIcon(i)" class="icon" />
                    <span class="date" :style="{ color: item.status === 1 ? '#b63b3b' : '' }">
                      {{ item.time }}
                    </span>
                  </div>
                  <div class="context">{{ item.context }}</div>
                </div>
              </div>
            </div>

            <!-- 新服预约：仅阶段 3 展示 -->
            <div v-if="pageStep === 3" class="appoint-box">
              <div v-if="bookStatus && !bookTime" class="tv-box tv-stage-3"></div>
              <div v-if="bookStatus && bookTime" class="tv-box tv-stage-2">
                <div class="time-box">
                  <div class="time-block"><span>{{ countdown.days }}</span></div>
                  <div class="time-block"><span>{{ countdown.hours }}</span></div>
                  <div class="time-block"><span>{{ countdown.minutes }}</span></div>
                  <div class="time-block"><span>{{ countdown.seconds }}</span></div>
                </div>
              </div>
              <div v-if="!bookStatus" class="tv-box tv-stage-1">
                <div class="land-btn" @click="book()"></div>
              </div>
              <div class="data-section">
                <div class="data-item">
                  <span class="number orange">{{ formatNumber(userCount) }}</span>
                  <span class="label">人口登记调查</span>
                </div>
                <div class="data-item">
                  <span class="number purple">{{ formatNumber(itemCount) }}</span>
                  <span class="label">物件被找回</span>
                </div>
              </div>
              <div class="rewards-box"></div>
              <div class="rule-btn" @click="showPopup('rulePopShow')"></div>
            </div>

            <!-- 乐园搜查小队：仅阶段 3 展示 -->
            <div v-if="pageStep === 3" class="team-container" id="team-consumption-box">
              <div class="team-info-box">
                <div class="team-header">队伍信息({{ memberNum }}/6)</div>

                <div class="team-content">
                  <div class="main-illustration">
                    <div class="team-name">{{ teamName }}</div>
                  </div>

                  <div class="member-list">
                    <div v-for="(m, i) in teamList" :key="i" class="member-item"
                      @click="m.id ? readPlayerInfo(m.id, 1) : onTeamShare()">
                      <div class="member">
                        <div :class="['avatar', { 'empty-avatar': !m.id }]">
                          <img v-if="m.avatar" :src="m.avatar" />
                          <div v-if="m.is_leader" class="captain"></div>
                        </div>
                        <span class="m-name">{{ m.id ? (m.is_myself ? '我' : m.account_nickname) : '待加入' }}</span>
                      </div>

                      <div class="m-score">
                        <template v-if="m.id">
                          调查进度: <span class="m-num">{{ !teamStatus ? 0 : Number(m.score || 0) }}</span>
                        </template>
                      </div>

                      <!-- 队员退队按钮 -->
                      <div v-if="m.is_myself && !is_leader && !teamStatus" class="kick-btn-2"
                        @click.stop="readPlayerInfo(m.id, 3)"></div>
                      <!-- 队长踢人按钮 -->
                      <div class="kick-btn" :style="{ visibility: m.is_kick_out ? 'visible' : 'hidden' }"
                        @click.stop="readPlayerInfo(m.id, 2)">
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="memberNum >= 6" class="invite-btn full-capacity-btn"></div>
                <div v-else class="invite-btn" data-snail-report-name="乐园搜查小组-邀请好友" @click="onTeamShare"></div>
              </div>

              <div class="team-rule-btn" @click="showPopup('rulePopShow2')"></div>

              <div class="progress-section">
                <div class="progress-header">
                  全队调查进度总额: <span class="score">{{ !teamStatus ? 0 : Number(teamScore || 0) }}</span>
                </div>

                <div class="scroll-wrapper" ref="teamProgressScroll">
                  <div class="progress-line-container">
                    <div class="progress-bar-bg">
                      <div class="progress-bar-fill" :style="{ width: calculatedWidth }"></div>
                    </div>

                    <div class="nodes">
                      <div v-for="step in steps" :key="step.id"
                        :class="['node', { reached: !teamStatus ? 0 : Number(teamScore || 0) >= step.value }]">
                        <div class="icon-box">
                          <!-- <img :src="step.icon" class="step-icon" /> -->
                        </div>
                        <div class="circle">
                          <span v-if="!teamStatus ? 0 : Number(teamScore || 0) >= step.value"></span>
                        </div>
                        <div class="value">{{ step.value }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="reward-section">
                <div class="reward-list">
                  <div v-for="r in rewards" :key="r.id" class="reward-item">
                    <div class="icon-box">
                      <img :src="r.img" />
                    </div>
                    <div :class="['claim-btn', { claimed: isRewardClaimed(r) }]">
                      {{ isRewardClaimed(r) ? '已领取' : r.require + '调查度' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 丫丫日记 -->
            <div class="diary-container">
              <!-- 顶部标题栏 -->
              <div class="diary-header">
                <span class="share-btn" data-snail-report-name="丫丫日记-分享日记" @click="shareDiary"></span>
              </div>

              <!-- 日记列表 -->
              <div class="diary-list">
                <div v-for="(item, i) in diaryList" :key="item.id" class="diary-item"
                  :class="{ 'is-abnormal': item.status !== 0 }">
                  <div class="diary-row">
                    <!-- 固定装饰图标：爱心(0)、蓝星(1)、黄星(2)循环 -->
                    <img :src="getFixedIcon(i)" class="icon" />
                    <span class="date" :style="{ color: item.status === 1 ? '#b63b3b' : '' }">
                      {{ item.time }}
                    </span>
                  </div>
                  <div class="context">{{ item.context }}</div>
                </div>
              </div>

              <!-- 分页控件 -->
              <div class="pagination">
                <div class="arrow arrow-left" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1"></div>
                <span>{{ currentPage }}/{{ lastPage }}</span>
                <div class="arrow arrow-right" @click="changePage(currentPage + 1)" :disabled="currentPage >= lastPage">
                </div>
              </div>
            </div>

            <!-- 污染报告 -->
            <div class="question-container">
              <!-- 1. 开始页面 -->
              <transition name="fade" mode="out-in">
                <div>
                  <div v-if="pageState === 'start'" class="page-start">
                    <div class="btn-start" data-snail-report-name="污染报告-开始认证" @click="startAnswer"></div>
                  </div>

                  <!-- 2. 答题页面 -->
                  <div v-else-if="pageState === 'answering'" class="page-answering">
                    <div class="q-title-img">
                      <img :src="questions[currentIndex].titleImg" alt="题目标题" />
                    </div>
                    <div class="options-grid">
                      <div v-for="(opt, i) in questions[currentIndex].options" :key="i" class="option-item"
                        @click="handleSelect(opt)">
                        <img :src="opt.icon" />
                      </div>
                    </div>
                    <div class="progress">进度:{{ currentIndex + 1 }}/10</div>
                  </div>

                  <!-- 3. 报告页面 -->
                  <div v-else-if="pageState === 'result'" class="page-result">
                    <div class="content-box">
                      <div class="left-box">
                        <!-- 1. 维度组合代码 (如 ECVD) -->
                        <div class="identity-code">{{ finalIdentity }}</div>
                        <!-- 2. 身份认证  -->
                        <div class="identity-name">{{ identityInfo.name }}</div>
                        <!-- 3. 身份说明 -->
                        <div class="identity-desc">{{ identityInfo.desc }}</div>
                      </div>
                      <div class="right-box">
                        <div class="memory-certification">
                          <div v-for="(cert, index) in selectedCerts" :key="index" class="cert-item">
                            · {{ cert }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 童年遗物展示区 -->
                    <div class="relic-section">
                      <div class="relic-grid">
                        <div v-for="(item, index) in selectedOptionIcons" :key="index" class="relic-item">
                          <img :src="item.selectIcon" />
                        </div>
                      </div>
                    </div>
                    <div class="save-btn" data-snail-report-name="污染报告-保存结果" @click="savePollutionReport"></div>
                    <!-- <div class="btn-restart" @click="resetTest"></div> -->
                  </div>

                  <!-- 隐藏的截图区域 -->
                  <div class="report-share-card" ref="reportShareDom">
                    <div class="share-content">
                      <div class="content-box">
                        <div class="left-box">
                          <!-- 1. 维度组合代码 (如 ECVD) -->
                          <div class="identity-code">{{ finalIdentity }}</div>
                          <!-- 2. 身份认证  -->
                          <div class="identity-name">{{ identityInfo.name }}</div>
                          <!-- 3. 身份说明 -->
                          <div class="identity-desc">{{ identityInfo.desc }}</div>
                        </div>
                        <div class="right-box">
                          <div class="memory-certification">
                            <div v-for="(cert, index) in selectedCerts" :key="index" class="cert-item">
                              · {{ cert }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- 童年遗物展示区 -->
                      <div class="relic-section">
                        <div class="relic-grid">
                          <div v-for="(item, index) in selectedOptionIcons" :key="index" class="relic-item">
                            <img :src="item.selectIcon" />
                          </div>
                        </div>
                      </div>
                      <div class="save-tip"></div>
                      <div class="share-code"></div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>

            <!-- 留言板 -->
            <div class="message-board">
              <div class="board-header">
                <div class="tread-box">
                  <div class="tread-btn" :class="canTread == 0 ? 'tread-btn-on' : 'tread-btn-off'" @click="handleTread"
                    data-snail-report-name="留言板-踩一踩">
                  </div>
                  <div class="tread-num">被踩：{{ treadNum }}</div>
                </div>
              </div>

              <!-- 留言列表：第一条在最顶部 -->
              <div class="message-list">
                <div v-for="msg in messages" :key="msg.id" class="message-item">
                  <div class="left-box">
                    <div class="user-info">
                      <div class="avatar-box">
                        <img :src="msg.avatar" class="avatar" />
                      </div>
                      <span class="username">{{ msg.username }}</span>
                    </div>
                    <div class="content">{{ msg.content }}</div>
                  </div>
                  <span class="date">{{ msg.date }}</span>
                </div>
              </div>

              <!-- 分页控件 -->
              <div class="pagination2">
                <div class="arrow arrow-left" @click="changePage2(currentPage2 - 1)"></div>
                <span>{{ currentPage2 }}/{{ lastPage2 }}</span>
                <div class="arrow arrow-right" @click="changePage2(currentPage2 + 1)"></div>
              </div>

              <!-- 输入区域 -->
              <div class="input-area">
                <input v-model="newComment" :placeholder="inputPlaceholder" :disabled="cdSeconds > 0" maxlength="60"
                  @focus="handleInputFocus" @input="checkLength" />
                <div class="submit-btn" data-snail-report-name="留言板-回复按钮"
                  :class="{ 'btn-on': canSubmit, 'btn-off': !canSubmit }" @click="submitComment">
                </div>
              </div>
            </div>

            <!-- <div class="box"></div> -->
            <!-- 组队消费分享：仅阶段 3 需要 -->
            <div v-if="pageStep === 3" class="team-share-box" ref="teamImageDom">
              <img src="https://download4.qcplay.com/qcgame-api/iInuVtxolzKsMu3PK9DKDyJD2ssLEz36xQmTluZT.png" />
              <div class="team-info">
                <p>当前小队人数：<span>{{ memberNum === 0 ? 1 : memberNum }}</span>人</p>
                <p>剩余<span>{{ memberNum === 0 ? 5 : Math.max(6 - memberNum, 0) }}</span>个空位</p>
              </div>
              <div class="share-img">
                <div class="qrcode-box">
                  <div id="team-qrcode" class="qrcode"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 版本页：点击“版本页”后整页切换到这里 -->
          <div v-show="activeIndex === 1" class="tab-page tab-page-version">
            <div class="version-content-box">
              <div class="content content-01">
                <div class="small-img-box">
                  <div v-for="index in 9" :key="index" :class="[`small-img`, `small-0${index}`]"
                    @click="openVersionPreview('01', index)"></div>
                </div>
              </div>
              <div class="content content-02">
                <div class="small-img-box">
                  <div v-for="index in 6" :key="index" :class="[`small-img`, `small-0${index}`]"
                    @click="openVersionPreview('02', index)"></div>
                </div>
              </div>
              <div class="content content-03">
                <div class="small-img-box">
                  <div v-for="index in 9" :key="index" :class="[`small-img`, `small-0${index}`]"
                    @click="openVersionPreview('03', index)"></div>
                </div>
              </div>
              <div class="content content-04">
                <div class="small-img-box">
                  <div v-for="index in 6" :key="index" :class="[`small-img`, `small-0${index}`]"
                    @click="openVersionPreview('04', index)"></div>
                </div>
              </div>
              <div class="content content-05">
                <div class="single-img" @click="openVersionPreview('05', 1)"></div>
              </div>
            </div>
          </div>

          <!-- 外部页：点击“外部页”后整页切换到这里 -->
          <div v-show="activeIndex === 2" class="tab-page tab-page-outside">
            <div class="outside-content-box">
              <div v-for="(item, index) in outsideLinks" :key="index" :class="['content', `content-0${index + 1}`]">
                <div class="jump-btn" @click="goOutsideLink(item)" :data-snail-report-name="`运营活动-跳转链接-活动${index + 1}`">
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 版本详情弹窗 -->
        <div class="version-preview-wrap popup_wrap" v-show="versionPreviewShow" @touchmove.prevent>
          <div ref="versionPreviewBox" class="version-preview-box" @touchmove.stop>
            <img :src="versionPreviewImg" />
          </div>
          <div class="close-bg" @click="versionPreviewShow = false"></div>
        </div>

        <!-- 丫丫日记分享弹窗 -->
        <div class="diary-save-wrap popup_wrap" v-show="diarySaveShow" @touchmove.prevent>
          <div class="diary-save-box" @touchmove.stop>
            <img :src="diarySaveImg" alt="丫丫日记分享" />
            <div class="close-btn" @click="diarySaveShow = false"></div>
          </div>
          <div class="close-bg" @click="diarySaveShow = false"></div>
        </div>

        <!-- 污染报告截图弹窗 -->
        <div class="report-save-wrap popup_wrap" v-show="reportSaveShow" @touchmove.prevent>
          <div class="report-save-box" @touchmove.stop>
            <img :src="reportSaveImg" alt="污染报告结果" />
            <div class="close-btn" @click="reportSaveShow = false"></div>
          </div>
          <div class="close-bg" @click="reportSaveShow = false"></div>
        </div>

        <!-- 新服预约规则弹窗 -->
        <div class="rule-pop-wrap popup_wrap" v-show="rulePopShow" @touchmove.prevent>
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="rule-pop-content" v-show="rulePopShow" @touchmove.stop>
              <div class="content">
                <img src="../../../../assets/images/active/snail/yayaLand/popup/rule.png" alt="">
              </div>
              <div class="close-btn" @click="closePopup('rulePopShow')"></div>
              <div class="close-btn-2" @click="closePopup('rulePopShow')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="rulePopShow" @click="closePopup('rulePopShow')"></div>
        </div>

        <!-- 组队消费规则弹窗 -->
        <div class="rule-pop-wrap rule-pop-wrap-2 popup_wrap" v-show="rulePopShow2" @touchmove.prevent>
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="rule-pop-content" v-show="rulePopShow2" @touchmove.stop>
              <div class="content">
                <img src="../../../../assets/images/active/snail/yayaLand/popup/rule_2.png" alt="">
              </div>
              <div class="close-btn" @click="closePopup('rulePopShow2')"></div>
              <div class="close-btn-2" @click="closePopup('rulePopShow2')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="rulePopShow2" @click="closePopup('rulePopShow2')"></div>
        </div>

        <!-- 组队消费——玩家信息弹窗 -->
        <div class="team-player-info-wrap popup_wrap" v-show="teamPlayerInfoShow1">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow1">
              <div class="player-info">
                <div class="top">
                  <div class="avatar-box">
                    <img class="avatar" :src="curPlayerInfo.avatar" alt="">
                  </div>
                  <div class="name">{{ curPlayerInfo.account_nickname || '' }}</div>
                </div>

                <div class="info">
                  <div class="row">
                    <div class="label">账号状态：</div>
                    <div class="value">{{ curPlayerInfo.type_desc || '' }}</div>
                  </div>
                  <div class="row">
                    <div class="label">上次登录时间：</div>
                    <div class="value">{{ `${curPlayerInfo.lastTime || ''}` }}</div>
                  </div>
                  <div class="row">
                    <div class="label">贡献积分：</div>
                    <div class="value">{{ !teamStatus ? 0 : curPlayerInfo.score }}</div>
                  </div>
                </div>
              </div>

              <div :class="'btn-box align-false'">
                <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow1')"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamPlayerInfoShow1')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamPlayerInfoShow1" @click="closePopup('teamPlayerInfoShow1')"></div>
        </div>

        <!-- 组队消费——队长踢人弹窗 -->
        <div class="team-player-info-wrap-2 popup_wrap" v-show="teamPlayerInfoShow2">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow2" @touchmove.stop>
              <div class="player-info">
                <div class="top">
                  <div class="avatar-box">
                    <img class="avatar" :src="curPlayerInfo.avatar" alt="">
                  </div>
                  <div class="name">{{ curPlayerInfo.account_nickname || '' }}</div>
                </div>

                <div class="info">
                  <div class="row">
                    <div class="label">账号状态：</div>
                    <div class="value">{{ curPlayerInfo.type_desc || '' }}</div>
                  </div>
                  <div class="row">
                    <div class="label">上次登录时间：</div>
                    <div class="value">{{ `${curPlayerInfo.lastTime || ''}` }}</div>
                  </div>
                  <div class="row">
                    <div class="label">贡献积分：</div>
                    <div class="value">{{ !teamStatus ? 0 : curPlayerInfo.score }}</div>
                  </div>
                </div>
              </div>

              <div :class="'btn-box align-' + curPlayerInfo.is_kick_out">
                <!-- <div :class="'btn-box align-true'"> -->
                <!-- <div class="btn" v-if="curPlayerInfo.is_kick_out"> -->
                <div class="btn">
                  <div v-if="showGrayKickOutBtn" class="gray-kick-out-btn">
                    <span>倒计时:{{ kickOutSeconds }}秒</span>
                  </div>
                  <div v-else class="kick-out-btn" @click="onKickOut(2)"></div>
                </div>
                <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow2')"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamPlayerInfoShow2')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamPlayerInfoShow2" @click="closePopup('teamPlayerInfoShow2')"></div>
        </div>

        <!-- 组队消费——队员退队弹窗 -->
        <div class="team-player-info-wrap-3 popup_wrap" v-show="teamPlayerInfoShow3">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow3" @touchmove.stop>

              <div class="player-info">
                <div class="top">
                  <div class="avatar-box">
                    <img class="avatar" :src="curPlayerInfo.avatar" alt="">
                  </div>
                  <div class="name">{{ curPlayerInfo.account_nickname || '' }}</div>
                </div>
              </div>
              <div class="btn-box">
                <div class="btn kick-out-btn" @click="onKickOut(1)"></div>
                <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow3')"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamPlayerInfoShow3')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamPlayerInfoShow3" @click="closePopup('teamPlayerInfoShow3')"></div>
        </div>

        <!-- 组队消费——邀请入队弹窗 -->
        <div class="team-invitation-join-wrap popup_wrap" v-show="teamInvitationJoinShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-invitation-join-box popup_wrap-box" v-show="teamInvitationJoinShow">
              <div class="team-info">
                <p>当前小队人数:<span>{{ teamInvitationNum === 0 ? 1 : teamInvitationNum }}</span></p>
                <p>剩余空位：<span>{{ teamInvitationNum === 0 ? 5 : Math.max(6 - teamInvitationNum, 0) }}</span></p>
                <p>当前调查进度：<span>{{ teamLevel }}</span></p>
              </div>
              <div class="btn-box">
                <div class="btn agree-btn" data-snail-report-name="组队消费-立即入队" @click="agreeJoinTeam()"></div>
                <div class="btn reject-btn" data-snail-report-name="组队消费-拒绝入队" @click="rejectJoinTeam()"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamInvitationJoinShow')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamInvitationJoinShow" @click="closePopup('teamInvitationJoinShow')">
          </div>
        </div>

        <!-- 组队消费——微信分享 -->
        <div class="team-wechat-share-wrap popup_wrap" v-show="teamWechatShareShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-wechat-share-box popup_wrap-box" v-show="teamWechatShareShow">
            </div>
          </transition>
          <div class="close-bg" v-show="teamWechatShareShow" @click="closeWechatShare('teamWechatShareShow')">
          </div>
        </div>
        <!-- 组队消费——分享弹窗 -->
        <div class="team-share-wrap popup_wrap" v-show="teamNotWechatShareShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-share-wrap-box popup_wrap-box" v-show="teamNotWechatShareShow">
              <div class="close-btn" @click="closePopup('teamNotWechatShareShow')"></div>
              <img :src="teamShareImg" alt="分享图片" />
              <div class="share-tips"></div>
              <button class="monitor-btn" @click="onCopy('team-clipboard-btn')" id="team-clipboard-btn"
                data-snail-report-name="付费活动弹窗-复制链接" data-event="复制邀请链接"
                :data-clipboard-text="teamShareCopy.linkText + teamShareLink"></button>
            </div>
          </transition>
          <div class="close-bg" v-show="teamNotWechatShareShow" @click="closePopup('teamNotWechatShareShow')">
          </div>
        </div>
        <!-- 组队消费——入队失败(满员) -->
        <div class="team-join-failed-full-strength-wrap popup_wrap" v-show="teamJoinFailedFullStrengthShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-join-failed-full-strength-box popup_wrap-box" v-show="teamJoinFailedFullStrengthShow">
              <div class="btn-box">
                <div class="btn other-active-btn" @click="toIndex('teamJoinFailedFullStrengthShow')"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamNotWechatShareShow')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamJoinFailedFullStrengthShow"
            @click="closePopup('teamJoinFailedFullStrengthShow')">
          </div>
        </div>
        <!-- 组队消费——入队失败(已有队伍) -->
        <div class="team-join-failed-has-team-wrap popup_wrap" v-show="teamJoinFailedHasTeamShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-join-failed-has-team-box popup_wrap-box" v-show="teamJoinFailedHasTeamShow">
              <div class="btn-box">
                <div class="btn other-active-btn" @click="toIndex('teamJoinFailedHasTeamShow')"></div>
                <div class="btn my-team-btn" @click="toMyTeamByTeam()"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamJoinFailedHasTeamShow')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamJoinFailedHasTeamShow" @click="closePopup('teamJoinFailedHasTeamShow')">
          </div>
        </div>
        <!-- 组队消费——入队失败(自己邀请自己) -->
        <div class="team-join-failed-myself-wrap popup_wrap" v-show="teamJoinFailedMyselfShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-join-failed-myself-box popup_wrap-box" v-show="teamJoinFailedMyselfShow">
              <div class="btn-box">
                <div class="btn other-active-btn" @click="toIndex('teamJoinFailedHasTeamShow')"></div>
                <div class="btn my-team-btn" @click="toMyTeamByTeam()"></div>
              </div>
              <div class="close-btn" @click="closePopup('teamJoinFailedMyselfShow')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamJoinFailedMyselfShow" @click="closePopup('teamJoinFailedMyselfShow')">
          </div>
        </div>

        <!-- 全局遮罩 -->
        <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
        <!-- 微信下载 -->
        <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
            :duration="{ enter: 1000 }">
            <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
          </transition>
          <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { GetRoleList, BindRoleAPI } from "@/api/os";
import Login from '@/components/login';
import Os from '@/components/os';
import Header from '../Header/index.vue';
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
// import { headerConfig } from '../headerConfig';
import {
  onGetInitDataAPI, bookAPI, getDiaryAPI, getMessageAPI, getShareAPI, postCommentAPI, pushStepAPI, teamKickAPI, teamJoinAPI, onGetTimeAPI, onGetShowTimeAPI, downloadApps
} from '../api';
import { questions, identities } from '../data'; // 导入数据
import { getRandomString, buriedLogger, wechatBrowser, getTimeStamp, analysisParams } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '../howler'
import QCJumpAuthPlugin from "@qcplay/jump-auth";

const PLAYER_TYPE = {
  1: '活跃玩家',
  2: '回归玩家',
  3: '新玩家',
};

export default {
  name: 'RecallTeamActive',
  components: {
    // Header,
    Login,
    swiper,
    swiperSlide,
    Os
  },
  data () {
    return {
      activeIndex: 0,
      // headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      rechargeUrl: 'https://pay.qingcigame.com/pay?gameId=39',
      loginTypes: ["sms", "password"],
      newUserInfo: {},
      autoOpenOS: true,
      logger: null,
      timer: null,

      music: null,
      isAudio: true,
      musicUnlocked: false,

      nowTime: '',

      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      teamShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },

      code: '',
      auth_code: '',
      teamShareLink: '',
      teamShareImg: '',

      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1164305.apk',
        ios_url: 'https://apps.apple.com/cn/app/%E6%9C%80%E5%BC%BA%E8%9C%97%E7%89%9B/id1507966188',
      },
      activitiesSwiper: null,
      gameFeatureSwiper: null,

      messageId: '',
      messageId_2: '',
      pageShareLink: '',

      shareRid: '',
      forceMyHome: false,

      preventShow: false,
      wxLoadShow: false,

      // ~~~~~~~~~~~~~~~~~~~~~~~
      // 用户信息
      userName: '',
      userAvatar: 'https://download4.qcplay.com/qcgame-api/OPPAlowGYCTL8hXngDfjXx9LhpdlchlKVGTf5zU1.png',
      userSign: '',

      pageStep: 0, // 0 初始化中，1 预热期，2 裂变期，3 组队期
      activityDataInited: false,
      // 设定乐园开启的日期
      targetDate: new Date(2026, 5, 16, 10, 0, 0).getTime(),
      timeLeft: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      timer: null,
      isBgmOn: true,
      activeIndex: 0,
      tabs: [
        { normal: require('@/assets/images/active/snail/yayaLand/head/nav_01_01.png'), active: require('@/assets/images/active/snail/yayaLand/head/nav_01_02.png') },
        { normal: require('@/assets/images/active/snail/yayaLand/head/nav_02_01.png'), active: require('@/assets/images/active/snail/yayaLand/head/nav_02_02.png') },
        { normal: require('@/assets/images/active/snail/yayaLand/head/nav_03_01.png'), active: require('@/assets/images/active/snail/yayaLand/head/nav_03_02.png') }
      ],
      userCount: 0, // 接口获取的数字
      itemCount: 0,

      bookStatus: 0,
      bookTime: 0,
      countdownTimer: null,

      // teamName: '读取中...', // 初始状态
      members: [],
      teamList: Array.from({ length: 6 }, () => ({})),
      rewards: [
        { id: 1, img: require('@/assets/images/active/snail/yayaLand/reward_icon_01.png'), require: 100, status: 1 },
        { id: 2, img: require('@/assets/images/active/snail/yayaLand/reward_icon_02.png'), require: 200, status: 1 },
        { id: 3, img: require('@/assets/images/active/snail/yayaLand/reward_icon_03.png'), require: 1500, status: 0 },
        { id: 4, img: require('@/assets/images/active/snail/yayaLand/reward_icon_04.png'), require: 5000, status: 0 },
      ],

      totalScore: 0,
      steps: [
        { id: 1, value: 30 },
        { id: 2, value: 60 },
        { id: 3, value: 100 },
        { id: 4, value: 130 },
        { id: 5, value: 160 },
        { id: 6, value: 200 },
        { id: 7, value: 300 },
        { id: 8, value: 400 },
        { id: 9, value: 600 },
        { id: 10, value: 800 },
        { id: 11, value: 1000 },
        { id: 12, value: 1200 },
        { id: 13, value: 1500 },
        { id: 14, value: 2000 },
        { id: 15, value: 2500 },
        { id: 16, value: 3000 },
        { id: 17, value: 4000 },
        { id: 18, value: 5000 },
        { id: 19, value: 7500 },
        { id: 20, value: 10000 },
        { id: 21, value: 15000 },
        { id: 22, value: 20000 },
        { id: 23, value: 25000 },
        { id: 24, value: 30000 },
        { id: 25, value: 35000 },
        { id: 26, value: 40000 },
        { id: 27, value: 45000 },
        { id: 28, value: 50000 },
        { id: 29, value: 60000 },
        { id: 30, value: 70000 },
        { id: 31, value: 80000 },
        { id: 32, value: 90000 },
        { id: 33, value: 100000 },
        { id: 34, value: 110000 },
        { id: 35, value: 120000 },
        { id: 36, value: 130000 },
        { id: 37, value: 140000 },
        { id: 38, value: 150000 },
        { id: 39, value: 160000 },
        { id: 40, value: 170000 },
        { id: 41, value: 180000 },
        { id: 42, value: 190000 },
        { id: 43, value: 200000 },
      ],

      outsideLinks: [
        {
          id: 1,
          label: '六周年纪念奖章',
          url: 'https://qcg.ink/5lA8T1',
          time: '2026-06-19 05:00:00'
        },
        {
          id: 2,
          label: '六周年锦鲤抽奖',
          url: '',
          time: '2026-06-26 05:00:00'
        },
        {
          id: 3,
          label: '六周年官充福利',
          url: '',
          time: ''
        },
        {
          id: 4,
          label: '二创赢周边',
          url: 'https://www.taptap.cn/moment/816638792034156923?group_id=227162',
          time: '2026-06-22 10:00:00'
        }
      ],

      // outsideLinks: [
      //   { url: '' },
      //   { url: '' },
      //   { url: '' },
      //   { url: '' }
      // ],

      level: 0, // 等级

      diaryList: [
        {
          id: 1,
          time: '2000年9月1日',
          context: '开学啦！今天进了大大卷和香菇肥牛，大家背着新书包来买，真热闹。',
          status: 0
        },
        {
          id: 2,
          time: '2000年10月15日',
          context: '天冷了，梧桐叶落满地，烤肠机很香，小卖部里暖烘烘的，真舒服。',
          status: 0
        },
        {
          id: 3,
          time: '2000年11月18日',
          context: '马上千禧年了！我在柜台上摆满彩色糖果，希望能一直这么美好。',
          status: 0
        }
      ],
      shareDiaryList: [],
      currentPage: 1,
      lastPage: 1,

      pageState: 'start', // 可选值: 'start', 'answering', 'result'
      currentIndex: 0,
      scores: { S: 0, C: 0, V: 0, D: 0 },
      selectedCerts: [], // 用于存储选中的认证路径
      selectedOptionIcons: [], // 记录每题选择的两张图
      // selectedIcons: [], // 用于存储选中的选项图标路径
      questions: questions,
      identities: identities,

      messages: [
        {
          id: 1,
          avatar: 'https://download4.qcplay.com/snail/yaya/avatar/5.png',
          username: '404号游客',
          content: '这里怎么打不开了？',
          date: '2005-06-13 12:03'
        },
        {
          id: 2,
          avatar: 'https://download4.qcplay.com/snail/yaya/avatar/3.png',
          username: '李雷',
          content: '有人见过丫丫吗？',
          date: '2005-06-10 10:01'
        },
        {
          id: 3,
          avatar: 'https://download4.qcplay.com/snail/yaya/avatar/1.png',
          username: '★追风♂少年★',
          content: '我小时候是不是来过这里？',
          date: '2005-06-03 10:00'
        }
      ],
      newComment: '',
      cdSeconds: 0, // 当前剩余CD秒数
      timer2: null,
      currentPage2: 1,
      lastPage2: 1,

      treadNum: 0,
      canTread: 0,
      loading: false,

      // 组队
      teamStatus: 0,
      teamInvitationNum: 0,
      teamScore: 0,
      memberNum: 0,
      teamName: '读取中...',
      is_leader: false,

      versionPreviewImg: '',

      // 弹窗
      rulePopShow: false, //新服预约规则弹窗
      rulePopShow2: false, //组队消费规则弹窗
      versionPreviewShow: false, // 大图展示弹窗
      teamWechatShareShow: false, // 组队消费——微信分享弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow1: false, // 组队消费——玩家信息弹窗
      teamPlayerInfoShow2: false, // 组队消费——队长踢人弹窗
      teamPlayerInfoShow3: false, // 组队消费——队员退队弹窗
      teamKickOutTipShow: false, // 组队消费——玩家被踢出队伍弹窗
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗

      curPlayerInfo: {},
      teamLevel: 0,

      diarySaveShow: false,
      diarySaveImg: '',

      reportSaveShow: false,
      reportSaveImg: '',
      reportQrInited: false,

      diarySaveObjectUrl: '',
      reportSaveObjectUrl: '',
      teamSaveObjectUrl: '',

      pollutionReportCacheKey: 'yayaLand_pollution_report_cache',

      otherHomeTipLock: false,

      currentTime: '',

      showEndPage: false,
      timer3: null,
      endTime: new Date(2026, 6, 17, 5, 0, 0).getTime(),
    }
  },
  created () {
    this.checkEndPage();

    this.timer3 = setInterval(() => {
      this.checkEndPage();
    }, 1000);

    this.getTime();
    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
    if (this.isPC) {
      this.$router.push(`pc${getRandomString()}`);
      return
    }

    this.pageLink = window.location.href;
    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    const queryUA = urlParams.get('ua');
    this.messageId_2 = urlParams.get('message_id');
    this.shareRid = urlParams.get('rid') || '';

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('ua');
    // urlParams.delete('message_id');


    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    const params = analysisParams(window.location.href);
    const { download_id } = params;

    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: "【最强蜗牛】不思议乐园专题页",
      imgUrl: "https://download4.qcplay.com/qcgame-api/t2mfIHwRfeLGYqTI9wzfqvrK0d4CpMSxx8wjdrtX.png",
      desc: "进入不思议乐园，帮助小卖部老板丫丫，找回遗失的童年！",
    });

    this.initActivityStep();
    this.restorePollutionReport();
    // console.log(this.pageStep, "this.stepthis.stepthis.pageStep");

    /**
     * 第一阶段不调用任何接口
     */
    if (this.pageStep !== 1 && download_id) {
      downloadApps({ download_id, title: 'title' }).then((res) => {
        if (res.code === 200) {
          this.downloadUrls = res.data;
        }
      });
    }
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();


    // 创建一个数组，长度为6，里面元素是空对象
    this.teamList = Array.from({ length: 6 }, () => ({}));
    // 埋点
    const bl = buriedLogger('snail', '最强蜗牛_六周年庆专题页');
    this.logger = bl;

    // if (queryUA === 'snail') {
    //   this.rechargeUrl = 'https://pay.qingcigame.com/pay?gameId=39&ua=snail';
    // }

    if (this.pageStep !== 1) {
      this.initActivityData(true);
    }
  },
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => { }
      }
    }
  },
  mounted () {
    this.autoScrollToCurrentStep();
    this.scrollToCurrentStepAfterRender();

    document.addEventListener('click', this.handleGlobalClick, true);

    if (this.pageStep !== 1) {
      this.startStageAudio();
      // this.initAudio();
      // document.addEventListener('touchstart', this.unlockAudio, false);
      // document.addEventListener('click', this.unlockAudio, false);
    }

    this.$nextTick(() => {
      this.scrollToCurrentStep();
    });
  },
  computed: {
    isOtherHome () {
      return !this.forceMyHome &&
        !!this.messageId_2 &&
        String(this.shareRid || '') !== String(this.userInfo.role_id || '');
    },
    countdown () {
      const total = Math.max(Number(this.bookTime || 0), 0)

      const days = Math.floor(total / 86400)
      const hours = Math.floor((total % 86400) / 3600)
      const minutes = Math.floor((total % 3600) / 60)
      const seconds = total % 60

      return {
        days,
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      }
    },
    nodeWidth () {
      return 57;
    },
    currentScore () {
      return Number(this.teamScore) || 0;
    },
    // 当前应该定位到哪个 step
    currentStepIndex () {
      if (!this.steps.length) return 0;

      const score = this.currentScore;

      if (score < this.steps[0].value) {
        return 0;
      }

      for (let i = this.steps.length - 1; i >= 0; i--) {
        if (score >= this.steps[i].value) {
          return i;
        }
      }

      return 0;
    },

    // 进度条填充宽度
    calculatedWidth () {
      if (this.steps.length <= 1) return '0%';

      const score = this.currentScore;
      const lastIndex = this.steps.length - 1;

      if (score <= this.steps[0].value) {
        return '0%';
      }

      if (score >= this.steps[lastIndex].value) {
        return '100%';
      }

      let currentIndex = 0;

      for (let i = 0; i < this.steps.length - 1; i++) {
        const current = this.steps[i];
        const next = this.steps[i + 1];

        if (score >= current.value && score < next.value) {
          currentIndex = i;
          break;
        }
      }

      const current = this.steps[currentIndex];
      const next = this.steps[currentIndex + 1];

      const segmentPercent = (score - current.value) / (next.value - current.value);
      const progressIndex = currentIndex + segmentPercent;

      return `${(progressIndex / lastIndex) * 100}%`;
    },
    showNavigation () {
      // 只有在第 2, 3, 4 阶段显示 Header 和 Login
      return this.pageStep > 1 && this.pageStep < 5;
    },
    fullMembers () {
      const list = [...this.members]; // 接口返回的队员数组
      // 补齐剩下的位置，直到长度为 6
      while (list.length < 6) {
        list.push({ isEmpty: true }); // 标记为空位
      }
      return list;
    },

    finalIdentity () {
      const { S, C, V, D } = this.scores;
      const code = `${S > 50 ? 'E' : 'I'}${C > 50 ? 'C' : 'O'}${V > 50 ? 'V' : 'R'}${D > 50 ? 'D' : 'P'}`;
      return code;
    },
    identityInfo () {
      return this.identities[this.finalIdentity] || { name: "未知身份", desc: "" };
    },
    inputPlaceholder () {
      if (this.cdSeconds > 0) {
        const min = Math.floor(this.cdSeconds / 60);
        const sec = this.cdSeconds % 60;
        return `${min}分${sec}秒后，可再次留言！`;
      }
      return "留下你的脚印吧~";
    },
    canSubmit () {
      // 同时满足：输入框不为空 且 不在 CD 冷却时间内
      return this.newComment.trim().length > 0 && this.cdSeconds === 0;
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    pageStep (newVal, oldVal) {
      if (oldVal === 1 && newVal !== 1) {
        this.startStageAudio();
      }
    },
    step (newVal) {
      if (newVal !== 1) {
        this.$nextTick(() => {
          this.initActivityData(true);
        });
      }
    },
    userInfo: {
      async handler (newValue, oldValue) {
        if (this.pageStep === 1) return;

        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
          // this.refreshPageData();
        } else if (newValue.user_id !== oldValue.user_id) {
          const { game_id, role_name, role_id, server_name, server_id, access_token } = newValue

          const login_access_token = localStorage.getItem('yayaLand_token');

          const qcJumpAuth = new QCJumpAuthPlugin({ gameId: game_id || 39 })
          const url = await qcJumpAuth.generateLoginFreeUrl({
            gameId: game_id || 39, flag: 'pay-web', accessToken: access_token ? access_token : login_access_token,
            extraParams: {
              role_id: role_id,
              role_name,
              server_id,
              server_name,
              os: 'android',
            }
          })
          if (url) {
            this.rechargeUrl = url
          }

          if (oldValue.user_id) {
            // console.log('初始登陆/切换角色')
            // TAG: 初始登陆/切换角色的时候
            this.clearDate();

            // this.getTeamInit();
            this.refreshPageData();
            this.prepareTeamShare();

          }
          this.setUserInfo({ ...this.userInfo });
        }
      }
    },
    steps: {
      handler () {
        if (this.pageStep === 1) return;
        this.autoScrollToCurrentStep();
      },
      deep: true,
      immediate: true
    },

    teamScore: {
      handler () {
        if (this.pageStep === 1) return;
        this.autoScrollToCurrentStep();
      },
      immediate: true
    }
  },
  beforeDestroy () {
    clearInterval(this.timer);
    clearInterval(this.timer2);
    clearInterval(this.timer3);
    clearInterval(this.countdownTimer)

    document.removeEventListener('touchstart', this.unlockAudio);
    document.removeEventListener('click', this.unlockAudio);

    if (this.music) {
      this.music.stop();
      this.music.unload();
      this.music = null;
    }

    if (this.diarySaveObjectUrl) URL.revokeObjectURL(this.diarySaveObjectUrl);
    if (this.reportSaveObjectUrl) URL.revokeObjectURL(this.reportSaveObjectUrl);
    if (this.teamSaveObjectUrl) URL.revokeObjectURL(this.teamSaveObjectUrl);
  },
  methods: {
    checkEndPage () {
      const now = Date.now();

      if (now >= this.endTime) {
        this.showEndPage = true;
        clearInterval(this.timer3);
        this.timer3 = null;
      } else {
        this.showEndPage = false;
      }
    },
    showOtherHomeTip () {
      if (this.otherHomeTipLock) return;
      this.otherHomeTipLock = true;
      this.onToast('你正处于其他调查者的主页，快给他点踩留言吧~');
      setTimeout(() => {
        this.otherHomeTipLock = false;
      }, 2500);
    },
    async backToMyHome () {
      this.forceMyHome = true;
      this.messageId_2 = '';
      this.shareRid = '';

      window.history.replaceState(null, '', window.location.pathname);

      this.onPreventShow();
      try {
        await this.onInitDate();
        await this.fetchMessages(1);
      } finally {
        this.onPreventClose();
      }
    },
    savePollutionReportCache () {
      const cache = {
        pageState: 'result',
        currentIndex: this.currentIndex,
        scores: this.scores,
        selectedCerts: this.selectedCerts,
        selectedOptionIcons: this.selectedOptionIcons
      };
      localStorage.setItem(this.pollutionReportCacheKey, JSON.stringify(cache));
    },
    restorePollutionReport () {
      try {
        const cacheStr = localStorage.getItem(this.pollutionReportCacheKey);
        if (!cacheStr) return;
        const cache = JSON.parse(cacheStr);
        if (!cache || cache.pageState !== 'result') return;
        this.pageState = 'result';
        this.currentIndex = Number(cache.currentIndex) || this.questions.length - 1;
        this.scores = cache.scores || { S: 0, C: 0, V: 0, D: 0 };
        this.selectedCerts = Array.isArray(cache.selectedCerts) ? cache.selectedCerts : [];
        this.selectedOptionIcons = Array.isArray(cache.selectedOptionIcons) ? cache.selectedOptionIcons : [];
      } catch (error) {
        localStorage.removeItem(this.pollutionReportCacheKey);
      }
    },
    clearPollutionReportCache () {
      localStorage.removeItem(this.pollutionReportCacheKey);
    },
    getShareCanvasOptions (dom, scale = 2) {
      const width = dom.offsetWidth;
      const height = dom.offsetHeight;
      const canvas = document.createElement('canvas');

      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;

      return {
        canvas,
        scale,
        width,
        height,
        logging: false,
        useCORS: true,
        backgroundColor: null
      };
    },
    canvasToImageUrl (canvas, urlKey, type) {
      if (this[urlKey]) {
        URL.revokeObjectURL(this[urlKey]);
        this[urlKey] = '';
      }

      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error('canvas toBlob failed'));

          const objectUrl = URL.createObjectURL(blob);
          this[urlKey] = objectUrl;

          resolve(`${objectUrl}#${type}-${Date.now()}`);
        }, 'image/png');
      });
    },
    startBookCountdown () {
      clearInterval(this.countdownTimer)

      this.countdownTimer = setInterval(() => {
        if (Number(this.bookTime) <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
          this.bookTime = 0
          return
        }

        this.bookTime -= 1
      }, 1000)
    },
    startStageAudio () {
      if (this.pageStep === 1 || this.music) return;
      this.initAudio();
      document.addEventListener('touchstart', this.unlockAudio, false);
      document.addEventListener('click', this.unlockAudio, false);
    },
    getOutsideOpenTime (item) {
      if (!item) return '';

      if (item.id === 3) {
        const gameId = Number(this.userInfo.game_id);
        const openTime = gameId === 39
          ? '2026-06-26 05:00:00'
          : '2026-06-19 05:00:00';
        return openTime;
      }

      return item.time;
    },
    goOutsideLink (item) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      if (!item) {
        this.onToast('暂未开启，敬请期待~');
        return;
      }

      const openTime = this.getOutsideOpenTime(item);

      if (this.isNotStarted(openTime)) {
        this.onToast('暂未开启，敬请期待~');
        return;
      }

      const url = item.id === 3 ? this.rechargeUrl : item.url;

      console.log("url:", url);


      if (!url) {
        this.onToast('暂未开启，敬请期待~');
        return;
      }


      window.location.href = url;
    },
    isNotStarted (time) {
      if (!this.currentTime || !time) {
        return true;
      }

      const currentTimestamp = new Date(this.currentTime.replace(/-/g, '/')).getTime();
      const openTimestamp = new Date(time.replace(/-/g, '/')).getTime();

      return currentTimestamp < openTimestamp;
    },
    openVersionPreview (folder, index) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      if (folder == "02") {
        const box = this.$refs.versionPreviewBox
        box.style.height = 'auto'
      }

      this.logger.sum(`蜗牛_六周年庆专题页_版本介绍_查看图片_板块${folder}图${index}`);

      this.versionPreviewImg = require(`@/assets/images/active/snail/yayaLand/version/${folder}/${index}.png`);
      this.versionPreviewShow = true;
    },
    switchTab (index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      this.logger.sum(`蜗牛_六周年庆专题页_点击导航栏_${index + 1}`);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    formatTimeNum (num) {
      const value = Number(num);
      if (!isFinite(value) || value < 0) return '00';
      return value < 10 ? `0${value}` : `${value}`;
    },
    async initActivityStep () {
      const res = await onGetTimeAPI();
      if (res.code !== 200) return;

      const unlock = res.data.unlock || {};
      const fissionStatus = unlock.fission && unlock.fission.unlock_status; // 预组队
      const teamUpStatus = unlock.team_up && unlock.team_up.unlock_status; // 正式组队

      if (teamUpStatus === 1) {
        this.pageStep = 3; // 正式组队
        this.logger.sum('蜗牛_六周年庆专题页_正式组队页');

      } else if (fissionStatus === 1) {
        this.pageStep = 2; // 预组队
        this.logger.sum('蜗牛_六周年庆专题页_预组队页');
      } else {
        this.pageStep = 1; // 预热
      }

      this.pageStep == 3;


      if (this.pageStep !== 1) {
        this.$nextTick(() => {
          this.initActivityData(true);
        });
      }
    },
    initActivityData (isFirstStep = false) {
      if (this.activityDataInited) return;

      this.activityDataInited = true;

      this.fetchDiary(1);
      // console.log("API检查:", getMessageAPI);
      this.fetchMessages(1);

      this.onInitDate(isFirstStep);
    },
    // 事件委托
    handleGlobalClick (e) {
      const hasPopup = this.isShowLogin || this.isShowOs;

      if (this.isOtherHome && !hasPopup) {
        const allowClickSelectors = [
          '.message-board',
          '.back-my-home-btn',
          '.music-btn',
          '.login',
          '.login-wrapper',
          // '.header',
        ];

        const isAllowed = allowClickSelectors.some(selector => {
          return e.target.closest && e.target.closest(selector);
        });

        if (!isAllowed) {
          e.preventDefault();
          e.stopPropagation();
          this.showOtherHomeTip();
          return;
        }
      }

      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-snail-report-name')) {
          const reportName = el.getAttribute('data-snail-report-name');
          this.logger.sum(`蜗牛_六周年庆专题页_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    refreshPageData () {
      this.onInitDate();
      this.fetchDiary(1);
      this.fetchMessages(1);
    },
    async onInitShareDate () {
      const response = await getShareAPI({ message_id: this.messageId_2 });
      if (response.code == 200) {
        this.userName = response.data.share_info.nickname;
        this.userSign = response.data.share_info.signature;
        this.userAvatar = response.data.share_info.avatar;
        this.level = response.data.share_info.level || 0;
        this.treadNum = response.data.share_step_up;
        this.canTread = response.data.share_step_up_status;
      } else {
        this.onToast(response.message);
      }
    },
    // 初始化
    async onInitDate (isFirst = false) {
      if (!this.forceMyHome && (!this.messageId_2 || !this.shareRid)) {
        const urlParams = new URLSearchParams(window.location.search);
        this.messageId_2 = this.messageId_2 || urlParams.get('message_id') || '';
        this.shareRid = this.shareRid || urlParams.get('rid') || '';
      }

      const codeID = this.code || '';
      const authCode = this.auth_code || '';
      const response = await onGetInitDataAPI({ code: codeID, auth_code: authCode });

      this.onInitDataCallback({ ...response, needAccount: false });

      if (response.code == 403) {
        this.setUserInfo({});
        this.onToast(response.message);
      }

      if (response.code == 401) {
        this.changeLoginPopup(true);
        return;
      }

      if (response.code !== 200) {
        !isFirst && this.onToast(response.message);
        return;
      }
      this.getTeamListData();


      this.onInitDataCallback(response);
      this.setUserInfo(response.data.user_info);
      this.setActiveInfo(response.data.activity);

      const userInfo = response.data.user_info || {};
      const activeInfo = response.data.activity || {};
      const teamInfo = activeInfo.team_info || {};

      this.bookStatus = activeInfo.book_status;
      this.bookTime = Number(activeInfo.book_time || 0);
      this.userCount = activeInfo.book_num || 0;
      this.itemCount = activeInfo.collect_objects || 0;
      this.teamStatus = activeInfo.team_status;
      this.canTread = activeInfo.step_up_status;
      this.is_leader = activeInfo.is_leader;
      this.teamScore = !this.teamStatus ? 0 : teamInfo.total_score;
      this.messageId = userInfo.message_id;

      const isMyShareHome = this.messageId_2 &&
        this.shareRid &&
        userInfo.role_id &&
        String(this.shareRid) === String(userInfo.role_id);

      if (isMyShareHome) {
        this.forceMyHome = true;
        this.messageId_2 = '';
        this.shareRid = '';
        window.history.replaceState(null, '', window.location.pathname);
      }

      const { protocol, host } = window.location;
      this.pageShareLink = `${protocol}//${host}/snail/yayaLand/enter${getRandomString()}?message_id=${this.messageId}&rid=${userInfo.role_id}`;

      if (this.messageId_2 && !this.forceMyHome) {
        await this.onInitShareDate();
      } else {
        const activityOther = userInfo.activity_other || {};
        this.userName = activityOther.nickname;
        this.userSign = activityOther.signature;
        this.userAvatar = activityOther.avatar;
        this.level = activeInfo.level || 0;
        this.treadNum = Number(activeInfo.step_up) || 0;
        this.canTread = activeInfo.step_up_status;
      }


      if (this.code) {
        const { is_my, number, is_join, team_level, invite_game_id } = activeInfo;
        this.gameId = userInfo.game_id;

        if (is_my) {
          this.showPopup('teamJoinFailedMyselfShow');
        } else if (is_join) {
          this.showPopup('teamJoinFailedHasTeamShow');
        } else if (number === 6) {
          this.showPopup('teamJoinFailedFullStrengthShow');
        } else {
          if (invite_game_id !== this.gameId) {
            return this.onToast('组队失败！正式服用户无法和光子服用户进行组队');
          }
          this.teamInvitationNum = number;
          this.teamLevel = team_level;
          this.showPopup('teamInvitationJoinShow');
        }
      }

      this.prepareTeamShare();
    },
    async getTime () {
      const res = await onGetShowTimeAPI();
      if (res.code !== 200) return;
      this.nowTime = res.data.time;
      this.currentTime = res.data.time;
      // console.log("this.nowTime1111:", this.nowTime);
      this.startCountdown();
    },
    formatTimeToTimestamp (time) {
      const [date, clock] = time.split(' ');
      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute, second] = clock.split(':').map(Number);

      return new Date(year, month - 1, day, hour, minute, second).getTime();
    },
    // 预热期倒计时
    startCountdown () {
      if (this.pageStep !== 1) return;
      this.logger.sum('蜗牛_六周年庆专题页_预热页');

      const serverNow = this.formatTimeToTimestamp(this.nowTime);
      const localNow = Date.now();

      this.timer = setInterval(() => {
        const now = serverNow + (Date.now() - localNow);
        const distance = this.targetDate - now;

        if (!isFinite(distance) || distance <= 0) {
          clearInterval(this.timer);
          this.timeLeft = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
          };
          this.$nextTick(() => {
            this.initActivityData(true);
          });
          return;
        }

        this.timeLeft.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.timeLeft.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.timeLeft.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.timeLeft.seconds = Math.floor((distance % (1000 * 60)) / 1000);
      }, 1000);
    },
    autoScrollToCurrentStep () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToCurrentStep();
        }, 100);

        setTimeout(() => {
          this.scrollToCurrentStep();
        }, 300);

        setTimeout(() => {
          this.scrollToCurrentStep();
        }, 800);
      });
    },
    scrollToCurrentStepAfterRender () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToCurrentStep();
        }, 300);
      });
    },

    scrollToCurrentStep () {
      const scrollEl = this.$refs.teamProgressScroll;

      if (!scrollEl || !this.steps.length) return;

      const targetCenter = this.currentStepIndex * this.nodeWidth + this.nodeWidth / 2;
      const scrollLeft = targetCenter - scrollEl.clientWidth / 2;
      const finalScrollLeft = Math.max(scrollLeft, 0);

      scrollEl.scrollLeft = finalScrollLeft;

      // 调试用，确认是否真的设置成功
      // console.log('自动滚动信息：', {
      //   score: this.currentScore,
      //   currentStepIndex: this.currentStepIndex,
      //   targetStep: this.steps[this.currentStepIndex],
      //   clientWidth: scrollEl.clientWidth,
      //   scrollWidth: scrollEl.scrollWidth,
      //   finalScrollLeft,
      //   realScrollLeft: scrollEl.scrollLeft
      // });
    },
    async book () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      const res = await bookAPI({});
      this.onToast(res.message);
      this.onInitDate();
    },
    handleShare () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      this.onCopy("share-clipboard-btn");

      // console.log("执行分享逻辑");
    },
    initAudio () {
      if (this.pageStep === 1) return;

      Howler.autoUnlock = true;

      this.music = new Howl({
        src: [require('@/assets/images/active/snail/yayaLand/bg.mp3')],
        loop: true,
        volume: 0.6,
        html5: true,
        preload: true,
        onplay: () => {
          // console.log('BGM 播放成功');
          this.musicUnlocked = true;
          this.isAudio = true;
        },
        onplayerror: (id, error) => {
          // console.log('BGM 播放失败', error);
          this.musicUnlocked = false;
        },
        onloaderror: (id, error) => {
          // console.log('BGM 加载失败', error);
        }
      });

      this.playAudio();
    },

    playAudio () {
      if (this.pageStep === 1 || !this.music || !this.isAudio) return;

      try {
        this.music.play();
      } catch (error) {
        // console.log('BGM play catch', error);
      }
    },

    unlockAudio () {
      if (this.pageStep === 1 || !this.isAudio || this.musicUnlocked) return;
      this.playAudio();
    },

    audio () {
      if (this.pageStep === 1) return;

      if (!this.music) {
        this.initAudio();
        return;
      }

      this.isAudio = !this.isAudio;

      if (this.isAudio) {
        this.playAudio();
        // this.onToast('背景音乐已开启~');
      } else {
        this.music.pause();
        // this.onToast('背景音乐已关闭~');
      }

      this.logger && this.logger.sum('蜗牛_六周年庆专题页_点击音乐按钮');
    },
    // 千分位格式化函数
    formatNumber (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getTeamListData () {
      let teamList = this.activeInfo.team_info.members || [];
      // console.log("队伍：", teamList);
      teamList.forEach((item) => {
        const { y, m, d, status, is_leader } = item;
        item.is_leader = is_leader
        if (y) {
          item.lastTime = `${y}年前`;
        } else if (m) {
          item.lastTime = `${m}月前`;
        } else if (d) {
          item.lastTime = `${d}天前`;
        } else {
          item.lastTime = '今日';
        }
        // item.is_leader = this.activeInfo.is_leader;
        item.type_desc = PLAYER_TYPE[status];
        item.is_myself = this.userInfo.market_user_id === item.id;
        item.is_kick_out = this.activeInfo.team_status === 0 &&
          this.activeInfo.is_leader && !item.is_myself;
        // console.log(item.is_kick_out, "is_kick_out");
      });
      // 如果teamList长度小于6，用空对象填充
      if (teamList.length < 6) {
        const fillCount = 6 - teamList.length;
        const fillArray = Array.from({ length: fillCount }, () => ({}));
        teamList = teamList.concat(fillArray);
      }
      this.teamList = teamList;
      this.memberNum = this.activeInfo.team_info.members.length;
      this.teamName = this.activeInfo.team_info.team_name || '读取中...';
      this.teamScore = !this.teamStatus ? 0 : this.activeInfo.team_info.total_score;
      this.totalScore = this.teamScore;
    },
    async rejectJoinTeam () {
      // this.toIndex('teamInvitationJoinShow');
      this.closePopup('teamInvitationJoinShow');
    },
    async agreeJoinTeam () {
      this.onPreventShow();
      const response = await teamJoinAPI({ code: this.code });
      if (response.code !== 200) {
        this.closePopup('teamInvitationJoinShow');
        this.onToast(response.message);
        // this.code = '';
      } else {
        this.onToast('入队成功');
        this.code = '';
      }
      this.onPreventClose();
      this.closePopup('teamInvitationJoinShow');
      this.onInitDate();
    },
    readPlayerInfo (id, popupType) {
      // console.log("id:", id);
      // console.log("popupType:", popupType);
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      // popupType: 1(玩家信息) 2(队长踢人) 3(队员退队)
      this.showPopup(`teamPlayerInfoShow${popupType}`);
    },
    // 踢出队伍
    async onKickOut (team_type) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();

      const response = await teamKickAPI({ out_team_id: team_type == 2 ? this.curPlayerInfo.id : 0, team_type: team_type });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast(response.message);
        this.closePopup('teamPlayerInfoShow2');
        this.closePopup('teamPlayerInfoShow3');
        this.onInitDate();
        this.logger.sum('蜗牛_六周年庆专题页_弹窗-踢出队伍');
      }
      this.onPreventClose();
    },
    // 准备组队分享数据
    prepareTeamShare () {
      this.$nextTick(() => {
        const teamCode = this.userInfo.team_code;
        if (!teamCode) return;

        const { protocol, host } = window.location;
        this.teamShareLink = `${protocol}//${host}/snail/yayaLand/enter${getRandomString()}?code=${teamCode}`;

        this.initTeamShareData();
      });
    },
    // 分享图片设置
    generateTeamShareImage (successCallback, failedCallback) {
      if (!this.$refs.teamImageDom) {
        console.warn('分享图 DOM 不存在');
        failedCallback && failedCallback();
        return;
      }

      generateCanvasImage(this.$refs.teamImageDom)
        .then(async (canvas) => {
          this.teamShareImg = await this.canvasToImageUrl(canvas, 'teamShareObjectUrl', 'team');
          successCallback && successCallback();
        })
        .catch((err) => {
          failedCallback && failedCallback();
        });
    },
    onTeamShare () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      const teamCode = this.userInfo.team_code;
      // console.log("队伍邀请码：", teamCode);
      if (!teamCode) {
        this.onToast('组队信息加载中，请稍后再试');
        return;
      }


      const { protocol, host } = window.location;
      this.teamShareLink = `${protocol}//${host}/snail/yayaLand/enter${getRandomString()}?code=${teamCode}`;

      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?code=${teamCode}`;
        window.history.replaceState(null, '', newUrl);

        this.setShare({
          uri: this.pageLink,
          link: this.teamShareLink,
          title: this.teamShareCopy.title,
          imgUrl: "https://download4.qcplay.com/qcgame-api/t2mfIHwRfeLGYqTI9wzfqvrK0d4CpMSxx8wjdrtX.png",
          desc: this.teamShareCopy.desc,
        });
        this.teamWechatShareShow = true;
        this.logger.sum('蜗牛_六周年庆专题页_组队付费-引导遮罩')
      } else {
        this.onPreventShow();

        this.$nextTick(() => {
          this.generateTeamShareImage(() => {
            this.onPreventClose();
            this.teamNotWechatShareShow = true;
          }, () => {
            this.onPreventClose();
          })
        });
      }
    },
    closeWechatShare (popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, '', window.location.pathname);
    },
    toMyTeamByTeam () {
      this.closePopup('teamJoinFailedHasTeamShow');
      this.closePopup('teamJoinFailedMyselfShow');
      // TODO: 锁定到页面召回板块
      this.scrollIntoTeamBox();
    },
    scrollIntoTeamBox () {
      const targetElement = document.getElementById('team-consumption-box');
      if (targetElement) {
        targetElement.style.scrollMarginTop = '80px';
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    isRewardClaimed (reward) {
      return Number(this.teamScore || 0) >= Number(reward.require || 0)
    },
    // 跳转到首页
    toIndex (popupName) {
      this.closePopup(popupName);
      this.recallSharePlayerInfo = {};
      const { protocol, host } = window.location;
      window.location.href = `${protocol}//${host}/snail/yayaLand/enter${getRandomString()}`;
    },
    initTeamShareData () {
      if (this.pageStep === 1) {
        // console.log('第一阶段，不生成组队分享二维码');
        return;
      }

      // console.log("分享二维码this.teamShareLink", this.teamShareLink);

      try {
        this.teamShareCopy = {
          title: '【最强蜗牛】不思议乐园专题页',
          desc: '进入不思议乐园，帮助小卖部老板丫丫，找回遗失的童年！',
          linkText: '加入《最强蜗牛》乐园调查，为丫丫小卖部寻找失物，获得限定绿贵、奇点水晶、亵渎之眼等珍贵奖励，就差你了！',
        };

        this.$nextTick(() => {
          this.qrcode('team-qrcode', `${this.teamShareLink}`);
          this.$nextTick(() => {
            this.generateTeamShareImage();
          });
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        // console.log('组队分享初始化失败', err);
      }
    },
    // 生成二维码
    // qrcode (id, link) {
    //   generateQRCode(document.getElementById(id), {
    //     text: link,
    //     colorDark: '#3f3f3f',
    //     colorLight: '#bdbdbd'
    //   });
    // },
    qrcode (id, link) {
      this.$nextTick(() => {
        const el = document.getElementById(id);

        if (!el || !link) return;

        el.innerHTML = '';

        generateQRCode(el, {
          text: link,
          correctLevel: 3,
          colorDark: '#3f3f3f',
          colorLight: '#bdbdbd'
        });
      });
    },
    onCopy (id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', (e) => {
        if (id == 'share-clipboard-btn') {
          this.onToast('已复制链接，快将主页分享给其他调查者，为你点踩留言，共同调查乐园吧！');
        } else if (id == 'team-clipboard-btn') {
          this.onToast('已复制邀请链接');
        } else {
          this.onToast('复制成功');
        }

        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    async fetchDiary (page) {
      // console.log("准备调用接口，页码为：", page);
      const res = await getDiaryAPI({ page, limit: 3, share_limit: 6 });
      if (res.code === 200) {
        const { data, current_page, last_page } = res.data.get_diary;
        this.diaryList = data;
        this.currentPage = current_page;
        this.lastPage = last_page;
        this.shareDiaryList = res.data.share;
        // console.log("diaryList:", this.diaryList);
        // console.log("shareDiaryList:", this.shareDiaryList);
      }
    },
    changePage (page) {
      if (page >= 1 && page <= this.lastPage) this.fetchDiary(page);
    },
    getFixedIcon (index) {
      const icons = [
        require('@/assets/images/active/snail/yayaLand/diary_dec_icon_01.png'),  // 爱心
        require('@/assets/images/active/snail/yayaLand/diary_dec_icon_02.png'),  // 蓝星
        require('@/assets/images/active/snail/yayaLand/diary_dec_icon_03.png')   // 黄星
      ];
      return icons[index % 3]; // 循环使用
    },
    shareDiary () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      this.onPreventShow();

      this.$nextTick(() => {
        setTimeout(() => {
          generateCanvasImage(this.$refs.diaryShareDom)
            .then(async (canvas) => {
              this.diarySaveImg = await this.canvasToImageUrl(canvas, 'diarySaveObjectUrl', 'diary');
              this.diarySaveShow = true;
            })
            .catch((err) => {
              // console.log('丫丫日记分享生成失败', err);
              this.onToast('图片生成失败，请稍后再试');
            })
            .finally(() => {
              this.onPreventClose();
            });
        }, 300);
      });
    },

    startAnswer () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.pageState = 'answering'
    },
    handleSelect (opt) {
      // 累加逻辑保持不变
      this.scores.S += opt.scores.S;
      this.scores.C += opt.scores.C;
      this.scores.V += opt.scores.V;
      this.scores.D += opt.scores.D;

      this.selectedCerts.push(opt.cert);

      this.selectedOptionIcons.push({
        icon: opt.icon,
        selectIcon: opt.selectIcon
      });

      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex++;
      } else {
        this.pageState = 'result';
        this.savePollutionReportCache();
      }
    },
    initReportQRCode () {
      this.$nextTick(() => {
        const el = document.getElementById('report-qrcode');

        if (!el) return;

        el.innerHTML = '';

        generateQRCode(el, {
          text: window.location.href,
          colorDark: '#3f3f3f',
          colorLight: '#ffffff'
        });

        this.reportQrInited = true;
      });
    },
    savePollutionReport () {
      this.onPreventShow();

      this.$nextTick(() => {
        this.initReportQRCode();

        this.$nextTick(() => {
          setTimeout(() => {
            generateCanvasImage(this.$refs.reportShareDom)
              .then(async (canvas) => {
                this.reportSaveImg = await this.canvasToImageUrl(canvas, 'reportSaveObjectUrl', 'report');
                this.reportSaveShow = true;
              })
              .catch((err) => {
                // console.log('污染报告截图生成失败', err);
                this.onToast('图片生成失败，请稍后再试');
              })
              .finally(() => {
                this.onPreventClose();
              });
          }, 300);
        });
      });
    },
    async fetchMessages (page) {
      try {
        const res = await getMessageAPI({ page, limit: 3, message_id: this.messageId_2 });

        if (res.code === 200) {
          const { data, current_page, last_page } = res.data;
          // this.diaryList = data;
          this.currentPage2 = current_page;
          this.lastPage2 = last_page;
          // console.log("messages:", this.messages);
        }

        // 根据你的接口结构：res.data.data 是列表数组
        // 且留言内容在 remark 字段中，所以需要映射一下
        if (res && res.data && res.data.data) {
          this.messages = res.data.data.map(item => {
            return {
              id: item.id || Math.random(), // 如果没有唯一id，可以用临时方案
              avatar: item.remark.avatar,
              username: item.remark.nickname,
              content: item.remark.context,
              date: item.remark.created_at
            };
          });

          // 如果需要按时间排序
          this.messages.sort((a, b) => new Date(b.date) - new Date(a.date));
          // console.log("留言板数据已更新:", this.messages);
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    changePage2 (page) {
      if (page < 1 || page > this.lastPage2 || page === this.currentPage2) return;
      this.fetchMessages(page);
    },
    handleInputFocus () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        this.$refs.commentInput && this.$refs.commentInput.blur()
        return;
      }
    },
    // 限制最高 60 字符 (30 中文)
    // checkLength () {
    //   if (this.newComment.length > 60) {
    //     this.newComment = this.newComment.slice(0, 60);
    //   }
    // },
    getTextLength (text) {
      return text.replace(/[^\x00-\xff]/g, 'aa').length
    },

    cutTextByLength (text, maxLength) {
      let length = 0
      let result = ''

      for (const char of text) {
        length += /[^\x00-\xff]/.test(char) ? 2 : 1

        if (length > maxLength) break

        result += char
      }

      return result
    },

    checkLength () {
      if (this.getTextLength(this.newComment) > 60) {
        this.newComment = this.cutTextByLength(this.newComment, 60)
      }
    },

    // 开启 CD 倒计时
    startCd (seconds) {
      this.cdSeconds = seconds;
      this.timer2 = setInterval(() => {
        if (this.cdSeconds > 0) {
          this.cdSeconds--;
        } else {
          clearInterval(this.timer2);
        }
      }, 1000);
    },

    async submitComment () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.canSubmit) return;
      const res = await postCommentAPI({ context: this.newComment, message_id: this.messageId_2 });
      if (res.code === 200) {
        this.newComment = '';
        this.startCd(300);
        await this.fetchMessages(1);
        this.onInitDate();
      } else {
        this.onToast(res.message);
      }
    },
    // 点击踩一踩
    async handleTread () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.canTread == 1 || this.loading) return

      this.loading = true

      try {
        const res = await pushStepAPI({ message_id: this.messageId_2 });
        this.onToast(res.message);

        this.treadNum += 1;
        this.canTread = 1;
      } finally {
        this.loading = false;
      }
    },


    clearDate () {
      clearInterval(this.timer2);
      clearInterval(this.kickOutTimer);
      this.timer2 = null;
      this.kickOutTimer = null;

      this.activeIndex = 0;
      this.preventShow = false;
      this.wxLoadShow = false;
      this.loading = false;

      this.userName = '';
      this.userAvatar = 'https://download4.qcplay.com/qcgame-api/OPPAlowGYCTL8hXngDfjXx9LhpdlchlKVGTf5zU1.png';
      this.userSign = '';
      this.level = 0;

      this.userCount = 0;
      this.itemCount = 0;
      this.treadNum = 0;
      this.canTread = 0;

      this.teamName = '读取中...';
      this.teamList = Array.from({ length: 6 }, () => ({}));
      this.memberNum = 0;
      this.roleList = [];
      this.teamScore = 0;
      this.totalScore = 0;
      this.is_leader = false;
      this.curPlayerInfo = {};
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.kickOutSeconds = 0;
      this.showGrayKickOutBtn = false;

      this.messageId = '',
        // this.messageId_2 = '',
        this.pageShareLink = '',

        this.teamShareLink = '';
      this.teamShareImg = '';
      this.teamShareCopy = {
        title: '',
        desc: '',
        linkText: ''
      };

      this.diaryList = [
        {
          id: 1,
          time: '2000年9月1日',
          context: '开学啦！今天进了大大卷和香菇肥牛，大家背着新书包来买，真热闹。',
          status: 0
        },
        {
          id: 2,
          time: '2000年10月15日',
          context: '天冷了，梧桐叶落满地，烤肠机很香，小卖部里暖烘烘的，真舒服。',
          status: 0
        },
        {
          id: 3,
          time: '2000年11月18日',
          context: '马上千禧年了！我在柜台上摆满彩色糖果，希望能一直这么美好。',
          status: 0
        }
      ];
      this.shareDiaryList = [];
      this.currentPage = 1;
      this.lastPage = 1;

      this.messages = [
        {
          id: 1,
          avatar: 'https://download4.qcplay.com/snail/yaya/avatar/5.png',
          username: '404号游客',
          content: '这里怎么打不开了？',
          date: '2005-06-13 12:03'
        },
        {
          id: 2,
          avatar: 'https://download4.qcplay.com/snail/yaya/avatar/3.png',
          username: '李雷',
          content: '有人见过丫丫吗？',
          date: '2005-06-10 10:01'
        },
        {
          id: 3,
          avatar: 'https://download4.qcplay.com/snail/yaya/avatar/1.png',
          username: '★追风♂少年★',
          content: '我小时候是不是来过这里？',
          date: '2005-06-03 10:00'
        }
      ];
      this.newComment = '';
      this.cdSeconds = 0;
      this.currentPage2 = 1;
      this.lastPage2 = 1;

      this.pageState = 'start';
      this.currentIndex = 0;
      this.scores = { S: 0, C: 0, V: 0, D: 0 };
      this.selectedCerts = [];
      this.selectedOptionIcons = [];
      this.diarySaveShow = false;
      this.diarySaveImg = '';
      this.reportSaveShow = false;
      this.reportSaveImg = '';
      this.reportQrInited = false;

      this.diarySaveObjectUrl = '';
      this.reportSaveObjectUrl = '';
      this.teamSaveObjectUrl = '';

      this.rulePopShow = false;
      this.rulePopShow2 = false;
      this.teamWechatShareShow = false;
      this.teamNotWechatShareShow = false;
      this.teamPlayerInfoShow1 = false;
      this.teamPlayerInfoShow2 = false;
      this.teamPlayerInfoShow3 = false;
      this.teamJoinFailedFullStrengthShow = false;
      this.teamJoinFailedHasTeamShow = false;
      this.teamJoinFailedMyselfShow = false;
      this.teamInvitationJoinShow = false;

      this.clearPollutionReportCache();
    },
    downloadApps () {
      const isWechat = wechatBrowser()
      if (isWechat) {
        this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls;
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    enterUrl () {
      const { label, url, time } = this.activitiesCards.find((i, index) => index === this.activeIndex) || {}
      if (this.isNotStarted(time)) return
      this.goLink(url, `蜗牛_六周年庆专题页_${label}跳转`)
    },

    // 角色选弹窗
    async onBindRolePopup () {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      // 获取角色信息 打开角色选择弹窗
      const roleResponse = await GetRoleList({
        account: this.userInfo.account,
        page_id: PAGE_ID[this.gameName],
        app_id: APP_ID[this.gameName]
      });

      if (Number(roleResponse.code) === 200) {
        // 正式服ID
        // const serverIds = GAME_AREA[this.gameName][1].id;
        // let data = roleResponse.data[serverIds] || [];
        // this.roleList = data['android'];
        // this.selectedRoleID = null;
        // this.selectedRoleInfo = {};
        // this.showPopup("snailRoleSelect");
        let data = roleResponse.data[this.user_info.game_id];
        this.roleList = data["android"];
        this.selectedRoleID = "";
        this.selectedRoleInfo = {};
        this.showPopup("snailRoleSelect");
      }
    },
    loginSuccess () {
      // console.log('登录成功');
      // this.onInitDate();
    },
    osCancell () {
    },
    loginCallback (response) {
      // console.log("res:", response);
      localStorage.setItem('yayaLand_token', response.data.access_token);
    },
    async getSelectInfo (selectInfo) {
      this.clearDate();
      this.selectInfo = selectInfo;
      selectInfo.account = this.userInfo.account;
      this.setUserInfo(selectInfo);
      this.refreshPageData();
    },
    // TAG: 其他简易封装的方法
    onToast (config, duration) {
      const curConfig = {
        duration: duration || 2000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    // 打开遮罩
    onPreventShow () {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose () {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup (name) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      this[name] = true;
    },
    closePopup (name) {
      this[name] = false;
    },
    inputFocus () {
      if (this.timer2) {
        clearTimeout(this.timer2);
      }
    },
    inputFocusOut () {
      this.timer2 = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
}


</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/yayaLand/index/index.vue